import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "../store/configureStore";
import ZonesService from "Services/zones";
import { IZoneAdv } from "../types/zoneAdv";

interface IZoneAdvState {
  loading: boolean;
  data: IZoneAdv[];
  errors: any;
}

const initialState: IZoneAdvState = {
  loading: false,
  data: [],
  errors: {},
};

const zonesAdvSlice = createSlice({
  name: "zonesAdv",
  initialState,
  reducers: {
    setLoader: (state) => {
      state.loading = true;
      state.errors = initialState.errors;
    },
    setData: (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.data = payload;
    },
    setError: (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.errors = payload;
    },
  },
});

const { setLoader, setData, setError } = zonesAdvSlice.actions;

export const getAdvZones = (): AppThunk => async (dispatch) => {
  dispatch(setLoader());
  try {
    const response = await ZonesService.getAdvZones();
    dispatch(setData(response));
  } catch (error) {
    dispatch(setError(error));
  }
};

export default zonesAdvSlice.reducer;
